import { getAvatar } from '@/scripts/utils/genAvatar';
import styles from './index.module.scss';
import type { MemberItemProps } from './type';

const MemberItem = ({
  className,
  name,
  remarkName,
  shortName,
  checked,
  disabled = false,
  showCheck = true,
  onClick = () => {},
  groupTag,
  hoverable = false,
  extra = <></>,
  avatarProps,
}: MemberItemProps) => {
  const { size = 'small', src, ...restAvatarProps } = avatarProps;
  return (
    <div
      className={cls(
        styles.memberItem,
        {
          [styles.showCheck]: !disabled && (showCheck || hoverable),
        },
        className
      )}
      onClick={() => {
        if (disabled) return;
        onClick();
      }}
    >
      {showCheck && (
        <Checkbox
          disabled={disabled}
          className={styles.checkbox}
          checked={checked}
        ></Checkbox>
      )}

      <MyAvatar size={size} src={getAvatar(src, name)} {...restAvatarProps}></MyAvatar>
      <div className={styles.content}>
        <div className={styles.info}>
          <div className={styles.name}>{name}</div>
          {remarkName && <div className={styles.remarkName}>({remarkName})</div>}
          {groupTag}
        </div>
        {shortName && <div className={styles.footer}>@{shortName}</div>}
      </div>
      {extra}
    </div>
  );
};
export default MemberItem;
